import type { FaireProductEntity } from "../../entity_types/product";

export const p_cxsqdjcb3m: FaireProductEntity = {
  token: "p_cxsqdjcb3m",
  type: "product",
  name: "Dainty Faceted Smoky Quartz beads + Solid Copper Bracelet",
  brandToken: "b_r3cuwn57s4",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d1c209dc6d40149dec586b1cc8ec356d5564ba140d8ea7b4e5c98e0de355d1d8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d296ffd21ff32d052eca8e85ed6d774e9026d4631557fb403ee50b735e1c47b3.jpeg",
    "https://cdn.faire.com/fastly/375aee3c3f6cd4a4ebd67ec1c7f914d189798e4da81aa63c223c4beb1e0aced0.jpeg",
    "https://cdn.faire.com/fastly/2545864dca11ae5e5fec0c19d52e7dcd9ae42de1a30114a447fcb70fb962f674.jpeg",
  ],
  priceDollars: 17,
  description:
    '\nFits most wrist. Size 6.5 - 7"\n\nDainty and Minimal Stretchy bracelets with multi-faceted 4mm Smoky Quartz + 3mm Solid copper beads Every bracelet comes with a tag that lists the properties of the gemstones and copper and is packed in a cotton pouch. \n\nPurported benefits of wearing a copper bracelet include the following: Relieves pain and inflammation caused by arthritis. Sterilizes wounds (due to its antibacterial properties) Improves the immune system. Works as an antioxidant. Prevents cardiovascular disease.\n',
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:23.793Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
